export class Application {
  uuid: string;
  code: string;
  name: string;
  description: string;
  tenantUuid: string;
  creationAt: Date;
  updatedAt: Date;
  url: string;
  icon: string;
  color: string;
}
